import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { loadActivatedRtFormTabEpic } from './loadActivatedRtFormTabEpic';
import { loadAfterRtQuoteTabContentFetchedEpic } from './loadAfterRtFormTabContentFetchedEpic';
import { persistRtQuoteTabContentEpic } from './persistRtQuoteTabTabContentEpic';
import { quoteRequestEpic } from './quoteRequestEpic';
import { tradeRequestEpic } from './tradeRequestEpic';
import { triggerRtQuoteTabContentEpic } from './triggerPersistRtQuoteTabTabContentEpic';

export const secondaryMarketRealtimeQuotes = () =>
  combineEpics(
    withAppCrashIfException('loadActivatedRtFormTabEpic', loadActivatedRtFormTabEpic()),
    withAppCrashIfException('quoteRequestEpic', quoteRequestEpic()),
    withAppCrashIfException('tradeRequestEpic', tradeRequestEpic()),
    withAppCrashIfException('triggerRtQuoteTabContentEpic', triggerRtQuoteTabContentEpic()),
    withAppCrashIfException('persistRtQuoteTabContentEpic', persistRtQuoteTabContentEpic()),
    withAppCrashIfException('loadAfterRtQuoteTabContentFetchedEpi', loadAfterRtQuoteTabContentFetchedEpic()),
  );
